export default "__VITE_ASSET__ChkwPQS$__"